import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { SettingDomainState } from './states'

const Domain: Module<SettingDomainState, State> = {
  state: new SettingDomainState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default Domain
